import Toast from "components/cms/Toast";
import PhotoHeroStack, { PHOTO_HERO_KEYS } from "components/cms/PhotoHeroStack";
import useCmsPage from "hooks/useCmsPage";
import { addCasePage, getCasePage, updateCasePage } from "api/casepage";
import { emptyCasesHero } from "utils/defaults";

export default function CasesPageCms() {
  const cms = useCmsPage({
    load: getCasePage,
    create: addCasePage,
    update: updateCasePage,
    empty: emptyCasesHero,
    mapResponse: (res) => res.data?.data,
  });
  const {
    form,
    setField,
    frMap,
    exists,
    loading,
    toast,
    setToast,
    save,
    saveSection,
    savingSection,
    isSectionDirty,
  } = cms;

  const onSave = () => {
    if (!exists) {
      save();
      return;
    }
    saveSection("hero", PHOTO_HERO_KEYS);
  };

  if (loading) {
    return <p className="mt-5 text-gray-600">Loading Cases page…</p>;
  }

  return (
    <div className="mt-3">
      <Toast toast={toast} onClose={() => setToast(null)} />
      {!exists ? (
        <p className="mb-3 text-sm text-gray-500">
          Cases hero is not saved yet. Click Save to create it. Until then the site
          keeps the current copy.
        </p>
      ) : null}
      <PhotoHeroStack
        form={form}
        setField={setField}
        frMap={frMap}
        hideId="cases-heroSectionHide"
        onSave={onSave}
        saving={savingSection === "hero" || savingSection === "all"}
        canSave={!exists || isSectionDirty(PHOTO_HERO_KEYS)}
      />
    </div>
  );
}
